import { Grid, Typography, useTheme } from '@mui/material'
import styled from 'styled-components/macro'

import UserIcon from '@mui/icons-material/AccountCircleOutlined'
import NumOfQuestionsIcon from '@mui/icons-material/HelpOutlineOutlined'
import TimeLimitIcon from '@mui/icons-material/AccessTime'

import { PublicCertificate } from 'src/types/graphql'
import { Icon } from '../Icon'
import { Countdown } from './Countdown'
import { switchProp } from 'styled-tools'
import { palette } from 'src/utils/styled'
import { CustomLinearProgress } from 'src/components/Utils/CustomLinearProgress/CustomLinearProgress'

const DataGridItem = styled(Grid)<{ color: 'primary' | 'secondary' }>`
    display: flex;
    align-items: center;

    color: ${switchProp('color', {
        primary: palette((p) => p.primary.main),
        secondary: palette((p) => p.secondary.main),
    })};
`

type CertificateQuizQuestionHeaderProps = {
    certificate: PublicCertificate
    onCountdownEnd: () => unknown
}

export function CertificateQuizQuestionHeader({ certificate, onCountdownEnd }: CertificateQuizQuestionHeaderProps) {
    const theme = useTheme()

    const progress = (certificate.numOfQuestionsAnswered / certificate.numOfQuestions) * 100

    return (
        <Grid container spacing={2} mb={4}>
            <Grid item xs={12}>
                <Typography variant="h4" fontWeight="bold">
                    {certificate.name}
                </Typography>
            </Grid>
            <DataGridItem item xs={5} color="secondary">
                <Icon tooltip="Teilnehmer">
                    <UserIcon />
                </Icon>
                <b>{certificate.user.name}</b>&nbsp;({certificate.user.email})
            </DataGridItem>
            <DataGridItem item xs={2} color="secondary">
                <Icon tooltip="Anzahl der Fragen, die beantwortet werden müssen">
                    <NumOfQuestionsIcon />
                </Icon>
                <b>
                    {certificate.numOfQuestionsAnswered + 1} / {certificate.numOfQuestions} Fragen
                </b>
            </DataGridItem>
            <DataGridItem item xs={2} color="primary">
                <Icon tooltip="Gesetztes Zeitlimit zur Beantwortung der Fragen">
                    <TimeLimitIcon />
                </Icon>
                {certificate.timeLimitMs === 0 ? (
                    <b>Kein Zeitlimit</b>
                ) : (
                    <b>
                        <Countdown startedAt={certificate.quizStartedAt!} maxDurationMs={certificate.timeLimitMs} onEnd={onCountdownEnd} />
                        &nbsp;verbleibend
                    </b>
                )}
            </DataGridItem>
            <Grid item xs={12} mt={2}>
                <CustomLinearProgress value={progress} color={[theme.palette.success.main]} thickness={2} />
            </Grid>
        </Grid>
    )
}
